// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"7322":"48f99088","8125":"1f1044d2"}[chunkId] + ".css";
};